// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo_T6CO4"};